import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

/**
 * TODO: Move to emergency_data.
 * This is a port of the `selectCallQueueBasedOnAniAliAccess` in
 * `callQueueSelectorNext`
 * Derives the phone number's data based on whether or not the user has access
 * to ANI/ALI features.
 * @param {Object} state - store.getState() object
 * @param {String} callerID - phone number
 */
// TODO: create another selector just for this for non Queue related features
// that need the call queue
const selectCallData = (state, callerID) => {
  return state?.emergencyCalls?.callQueue?.[callerID] ?? null;
};

const selectTextFrom911Conversation = (state, callerID) => {
  return state?.textFrom911?.conversations?.[callerID] ?? null;
};

/**
 * Custom selector that returns data for a given phone number using multiple
 * data sources.
 * Intended for the purposes of displaying indicators in the call queue UI.
 * Note: if another data source is needed, such as ADR or Video To 911, add
 * another selector function and update createSelector below
 * @param {String} callerID - phone number
 */
const numberFullDataSelector = createSelector(
  selectCallData,
  selectTextFrom911Conversation,
  (callData, textFrom911Data) => {
    return {
      callData,
      textFrom911Data,
    };
  },
);

const useFullSelectedNumberData = callerID => {
  const fullSelectedNumberData = useSelector(state =>
    numberFullDataSelector(state, callerID),
  );
  return fullSelectedNumberData;
};

export default useFullSelectedNumberData;
